import * as React from 'react';

const SvgCoingecko = (props) => (
  <svg
    width={40}
    height={40}
    className="fill-current text-black dark:text-white"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M40.2162 20.8258C40.2414 28.9225 35.4238 36.2372 27.9577 39.3649C20.4916 42.4926 11.8905 40.8279 6.13962 35.1274C0.388721 29.4269 -1.35168 20.8258 1.70033 13.3345C4.75234 5.84323 12.0419 0.949914 20.1133 0.899468C31.1863 0.874244 40.1658 9.77805 40.2162 20.8258Z"
      fill="black"
    />
    <path
      d="M38.7281 20.8255C38.7533 28.3168 34.2888 35.0766 27.3777 37.9773C20.4665 40.8779 12.5212 39.3141 7.19907 34.0677C1.87697 28.796 0.262679 20.8507 3.08768 13.9395C5.91268 7.00314 12.6473 2.48818 20.1134 2.43773C30.354 2.38728 38.6777 10.6101 38.7281 20.8255Z"
      fill="white"
    />
    <path
      d="M20.5674 3.624C21.7529 3.42221 22.9384 3.42221 24.1239 3.624C25.3094 3.80056 26.4696 4.20413 27.529 4.75904C28.5884 5.33918 29.4964 6.1211 30.4044 6.85257C31.3125 7.58404 32.2205 8.34074 33.0781 9.17311C33.9609 9.98025 34.7176 10.9135 35.3482 11.9224C36.004 12.9314 36.5337 14.016 36.9373 15.1258C37.7192 17.3959 37.9714 19.8425 37.5931 22.1631H37.4669C37.0886 19.8425 36.5589 17.6481 35.7265 15.5546C35.3482 14.4952 34.869 13.4611 34.3645 12.4773C33.8096 11.4936 33.2294 10.5099 32.5736 9.6019C31.9178 8.66864 31.0855 7.83628 30.1522 7.15525C29.219 6.47423 28.1344 6.04543 27.1002 5.64186C26.066 5.23829 25.0067 4.80949 23.9221 4.48159C22.8375 4.17891 21.7277 3.92668 20.5674 3.69967V3.624Z"
      fill="white"
    />
    <path
      d="M29.5974 14.2932C28.2606 13.9149 26.8733 13.36 25.4608 12.8051C25.3851 12.4519 25.0572 12.0231 24.4266 11.4682C23.5186 10.6611 21.7782 10.6863 20.29 11.0394C18.6505 10.6611 17.011 10.5098 15.4472 10.8881C2.659 14.4194 9.89807 22.9953 5.20654 31.6468C5.86235 33.0593 13.0762 41.3325 23.4934 39.1129C23.4934 39.1129 19.9369 30.5622 27.9831 26.4508C34.5159 23.1214 39.2075 16.9165 29.5974 14.2932Z"
      fill="black"
    />
    <path
      d="M20.29 11.0391C21.2233 11.1148 24.6032 12.1994 25.4608 12.8047C24.7293 10.7112 22.3079 10.4338 20.29 11.0391Z"
      fill="black"
    />
    <path
      d="M31.1863 19.9183C31.1863 20.5993 30.3539 20.9524 29.8747 20.4732C29.3955 19.994 29.7234 19.1616 30.4044 19.1364C30.8332 19.1616 31.1863 19.4895 31.1863 19.9183ZM21.1727 16.3618C21.1727 17.7995 20.2899 19.1111 18.953 19.666C17.6162 20.221 16.0776 19.9183 15.0434 18.8841C14.0093 17.85 13.7066 16.3114 14.2615 14.9745C14.8164 13.6377 16.128 12.7549 17.5658 12.7549C18.5242 12.7549 19.4323 13.1332 20.0881 13.789C20.7943 14.4953 21.1727 15.4033 21.1727 16.3618Z"
      fill="white"
    />
    <path
      d="M20.1135 16.3864C20.1135 17.3953 19.5082 18.3286 18.5497 18.7069C17.6164 19.0853 16.5318 18.8835 15.8004 18.152C15.0689 17.4206 14.8671 16.3612 15.2454 15.4027C15.6238 14.4694 16.5571 13.8389 17.566 13.8389C18.9785 13.8641 20.1135 14.9991 20.1135 16.3864Z"
      fill="black"
    />
    <path
      d="M34.0873 21.5072C31.1866 23.5503 27.8824 25.0889 23.2161 25.0889C21.0216 25.0889 20.5928 22.7684 19.1299 23.9034C18.3732 24.4835 15.75 25.7951 13.6565 25.7195C11.5629 25.6186 8.18301 24.3826 7.24975 19.9434C6.8714 24.4079 6.69484 27.6869 5.00488 31.4452C8.33435 36.7925 16.2797 40.9039 23.4935 39.1382C22.7116 33.7152 27.4536 28.4184 30.102 25.7195C31.1362 24.6601 33.0783 22.9954 34.0873 21.5072Z"
      fill="black"
    />
    <path
      d="M33.9607 21.6328C33.0527 22.4652 31.9933 23.0705 30.9087 23.6002C29.7989 24.1299 28.6639 24.5335 27.4784 24.8614C26.2929 25.1641 25.0569 25.3911 23.821 25.2902C22.5598 25.1893 21.2987 24.7605 20.4663 23.8272L20.5168 23.7768C21.5257 24.4326 22.7112 24.6596 23.8714 24.71C25.0569 24.7353 26.2424 24.6596 27.4027 24.4326C28.563 24.1804 29.7232 23.8272 30.8331 23.3732C31.9429 22.9192 33.0275 22.3895 33.986 21.6328H33.9607Z"
      fill="white"
    />
  </svg>
);

export default SvgCoingecko;
